// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UksPKqMaVWkwFO6EPnlD{width:100%;min-height:100%;padding:24px 80px 0}.UksPKqMaVWkwFO6EPnlD .NVJm76x5qeQit7YgIVzn{justify-content:flex-end;gap:8px;padding:64px 0;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UksPKqMaVWkwFO6EPnlD`,
	"actions": `NVJm76x5qeQit7YgIVzn`
};
export default ___CSS_LOADER_EXPORT___;
